import React from 'react';
interface PhotoCreditProps {
  children: React.ReactNode;
  credit: string;
  className?: string;
}
export function PhotoCredit({
  children,
  credit,
  className = ''
}: PhotoCreditProps) {
  return <div className={`relative ${className}`} data-id="element-177">
      {children}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" data-id="element-178" />
      <div className="absolute bottom-0 right-0 p-2 pr-3 pointer-events-none" data-id="element-179">
        <span className="text-[10px] text-white font-medium opacity-80 drop-shadow-sm" data-id="element-180">
          {credit}
        </span>
      </div>
    </div>;
}